import { Avatar } from "@maxhub/max-ui"
import { PlaceholderIcon } from "../shared/PlaceholderIcon"

export const AvatarOnlineDotExample = {
    title: 'Avatar.OnlineStatus',
    defaultPlatform: 'ios',
    defaultZoom: 100,

    controls: [],

    Preview({ props }){
        return (
            <Avatar.Container size={40} onlineStatus>
                <Avatar.Icon>
                    <PlaceholderIcon />
                </Avatar.Icon>
            </Avatar.Container>
        )
    },

    getCode(props){
        return `<Avatar.Container size={40} onlineStatus>
  <Avatar.Icon>
    <PlaceholderIcon />
  </Avatar.Icon>
</Avatar.Container>`
    }

}